import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { DropTarget as dropTarget } from 'react-dnd'

import { gridCreateTimeDeals, gridRemoveTime } from 'actions/grid'
import { GRID_DND_SIDEBAR_SELLABLE_ITEM } from 'constants/grid-constants'

import GridHeaderTime from './grid-header-time'

class GridHeaderTimeContainer extends Component {

  constructor(props) {
    super(props)

    this.onRemove = this.onRemove.bind(this)
  }

  onRemove() {
    this.props.gridRemoveTime(this.props.time.id)
  }

  render() {
    const { connectDropTarget } = this.props

    return connectDropTarget(
      <div>
        <GridHeaderTime {...this.props} onRemove={this.onRemove} />
      </div>
    )
  }
}

GridHeaderTimeContainer.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  gridCreateTimeDeals: PropTypes.func.isRequired,
  gridRemoveTime: PropTypes.func.isRequired,
  time: PropTypes.object.isRequired,
}

const gridHeaderTimeTarget = {
  drop(props, monitor) {
    const item = monitor.getItem()
    props.gridCreateTimeDeals(props.time.id, item.sellableItem.id)
  },
}

const collect = (targetConnect, monitor) => {
  const isOver = monitor.isOver()
  return {
    isOver,
    connectDropTarget: targetConnect.dropTarget(),
    color: isOver ? monitor.getItem().sellableItem.color : null,
    canDrop: monitor.canDrop(),
  }
}

const mapDispatchToProps = { gridCreateTimeDeals, gridRemoveTime }

const DNDGridHeaderTime = dropTarget(
  GRID_DND_SIDEBAR_SELLABLE_ITEM,
  gridHeaderTimeTarget,
  collect
)(GridHeaderTimeContainer)

export default connect(undefined, mapDispatchToProps)(DNDGridHeaderTime)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-header-time/grid-header-time-container.js
 **/